import React from 'react';
import Title from '@atoms/Title/Title';
import './_TextList.scss';

export default function TextList(props) {
    let mod_class = ['TextList'];

    const myData = props.data;
    const listItems = myData.map((item, index) => (
        <li key={index} className="TextList--item">
            <Title tag="span" size="m" theme="dark">
                {item}
            </Title>
        </li>
    ));
    return <ol className={mod_class}>{listItems}</ol>;
}
